import { nextTick } from 'vue'
import { gtm_page_category_identification } from '@/helpers/gtm'
import { i18n } from './locales/i18n'
import router from './router'
import store from './store'

router.beforeEach(async (to, from, next) => {
  const isShownUnderFlag =
    to.meta.isShownUnderFlag && !store.getters.user_has_flag(to.meta.isShownUnderFlag)
  const isHiddenUnderFlag =
    to.meta.isHiddenUnderFlag && store.getters.user_has_flag(to.meta.isHiddenUnderFlag)

  if (isShownUnderFlag || isHiddenUnderFlag) {
    next('/')
    return
  }

  if (from.name && from.name !== to.name) {
    store.commit('router_set', {
      key: 'from_path_name',
      value: from.name,
    })
  }

  next()
})

/**
 * Store the previous route in session storage
 */
router.beforeEach((to, from, next) => {
  if (from.name) {
    sessionStorage.setItem('previousRoute', encodeURIComponent(from.fullPath))
  }
  next()
})

/**
 * Remove the previous route from session storage when the page is unloaded
 */
window.onbeforeunload = () => {
  sessionStorage.removeItem('previousRoute')
}

const isLoginPath = path => path.startsWith('/login')

/**
 * Save the last non-login path when navigating from login page
 */
router.beforeEach((to, from, next) => {
  const realTo = to.redirectedFrom ?? to

  const fromLogin = isLoginPath(from.path)
  const toLogin = isLoginPath(realTo.path)

  if (realTo.fullPath && !toLogin && !fromLogin) {
    localStorage.setItem('redirect', realTo.fullPath)
  }

  next()
})

router.afterEach((to, from) => {
  nextTick(() => {
    store.dispatch('router_set_metatitle', { from, to })
    if (from.name !== to.name) {
      const { user_info } = store.getters
      // seg_page()
      gtm_page_category_identification({
        path_name: to.name,
        id: user_info.public_id || '',
        locale: i18n.locale,
        registered: 'yes',
        activatedGames: user_info.gtm_plans || '',
      })
    }
  })
})
